import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/retirement-readiness-calculator',
  component: () => import('../../routes/RetirementReadiness.svelte'),
  card: {
    id: 'retirement-readiness-calculator',
    title: 'Retirement Readiness Score',
    description: 'Calculate your retirement readiness score with a single composite metric. Get a grade (A–F) and actionable gap analysis.',
    icon: 'verified_user',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/retirement-readiness-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Retirement Readiness Score Calculator – Grade A–F Readiness Assessment',
    description: 'Free retirement readiness calculator. Calculate your composite readiness score (0–100) with letter grade A–F. Includes projected savings at retirement, FI number, and monthly savings gap analysis.',
  },
};

export default meta;
